import CustomButton from '../../ui/CustomButton';
import FeatureCard from '../../panels/FeatureCard';
import htmlStringToReactNodes from '../../../helpers/htmlStringToReactNodes';
const FeaturedGrid = ({
  name,
  cards,
  buttons,
  numberOfColumns
}) => <div id={`${name}-feature-grid`} style={{
  display: 'flex',
  flexWrap: 'wrap'
}} data-sentry-component="FeaturedGrid" data-sentry-source-file="FeaturedGrid.jsx">
    {cards.map(({
    title,
    showTitle,
    shortDescriptionHTML,
    size,
    page: {
      type,
      slug,
      name,
      imageURL
    }
  }) => <div key={slug} id={slug} style={{
    flex: `1 1 ${100 / numberOfColumns}%`,
    boxSizing: 'border-box',
    padding: '0.5rem'
  }}>
          <FeatureCard title={showTitle ? title : name} desc={htmlStringToReactNodes(shortDescriptionHTML)} url={{
      pathname: `/toolkits/${type}/[slug]`,
      query: {
        slug
      }
    }} size={size} image={<img src={imageURL} alt={name} />} />
        </div>)}
    {buttons.map(button => <div key={button.page.slug} id={button.page.slug} style={{
    flex: `1 1 ${100 / numberOfColumns}%`,
    boxSizing: 'border-box',
    padding: '0.5rem'
  }}>
        <CustomButton {...button} displayInaccessible title={button.title || button.page.name || button.name} url={{
      pathname: `/toolkits/${button.page.type}/[slug]`,
      query: {
        slug: button.page.slug
      }
    }} />
      </div>)}
  </div>;
export default FeaturedGrid;